<template>
    <ul class="absolute w-full left-0 top-0 shadow-lg border-gray-300 border-t user-menu" >
        <div class=" text-right w-full lg:hidden bg-white px-4">
            <language-switcher></language-switcher>
        </div>
        <menu-item
            v-for="(item, index) in menuItems"
            :key="index"
            :item="item"
            :disabled="hasPendingSubscription && !item.enabledForInactiveUser"
            @menu-clicked="$emit('menu-clicked')"
            class="border border-solid border-gray-400 border-l-0 border-t-0 border-r-0">
        </menu-item>
    </ul>
</template>

<script>
import { mapGetters } from 'vuex';
import NavigationLinks from '@/config/NavigationLinks';
import MenuItem from '@/components/partials/account/MenuItem';
import LanguageSwitcher from '@/components/structure/navigation/navigation/LanguageSwitcher';

export default {
    name: 'UserMenu',
    components: { MenuItem, LanguageSwitcher },
    computed: {
        ...mapGetters({
            hasPendingSubscription: 'subscription/hasPendingSubscription',
        }),
        menuItems() {
            return NavigationLinks.items
                .filter((item) => typeof item.hamburgerMenu !== 'undefined' && item.hamburgerMenu.enabled)
                .map((item) => Object.assign(item.hamburgerMenu, item))
                .sort((prevItem, nextItem) => prevItem.order - nextItem.order);
        },
    },
};
</script>
